import React from "react";
import { IPackage } from "pages/Packages/List/api";
import { StatusMessage } from "components/StatusMessage";
import { ViewDetails } from "components/ViewDetails";

import "./index.css";

interface Props {
  item: IPackage;
}

export function DroppedOff({ item }: Props) {
  return (
    <div>
      <StatusMessage message="We will notify you once we receive this package" actionType="admin"/>
      <div className="col-12">
        <p>Thank you for dropping off this package. We will get back to you once we receive this package.</p>
      </div>
      <hr/>
      <ViewDetails item={item} />
    </div>
  );
}
